import { List } from 'antd';

import {
    roundToAtMostTwoDecimals,
    STANDARD_MEAL_BREAK_MINUTES,
} from '@clh/util';

export const TimeWorkedSummary = ({
    onCall,
    worked,
    tookMealBreak,
    didNotWork,
}: {
    onCall: number;
    worked: number;
    tookMealBreak: boolean;
    didNotWork: boolean;
}) => {
    const calculateSummary = () => {
        const sum = [];

        const billableWorked =
            tookMealBreak && worked > 0
                ? worked - STANDARD_MEAL_BREAK_MINUTES / 60
                : worked;

        if (didNotWork) {
            return [
                <>Nurse did not work this shift</>,
                <>
                    Total hours paid: <b>0</b>
                </>,
            ];
        }

        if (onCall > 0) {
            sum.push(
                <>
                    On-call hours: <b>{roundToAtMostTwoDecimals(onCall)}</b>
                </>
            );
        }
        if (worked > 0) {
            sum.push(
                <>
                    Worked hours: <b>{roundToAtMostTwoDecimals(worked)}</b>
                </>
            );
        }
        if (tookMealBreak && worked > 0) {
            sum.push(
                <>
                    Meal break: <b>-{STANDARD_MEAL_BREAK_MINUTES / 60}</b>
                </>
            );
        }
        sum.push(
            <>
                Total hours paid:{' '}
                <b>{roundToAtMostTwoDecimals(billableWorked + onCall)}</b>
            </>
        );
        return sum;
    };

    const summary = calculateSummary();

    return (
        <List
            size="small"
            bordered
            dataSource={summary}
            renderItem={(item) => <List.Item>{item}</List.Item>}
        />
    );
};
